import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-mediapres",
  templateUrl: "./mediapres.component.html",
  styleUrls: ["./mediapres.component.scss"],
})
export class MediapresComponent implements OnInit {
  lif: any;
  lift = [];
  knowmore: any;
  richtext: any;
  know: any;
  displayStyles = "block";
  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.displayStyles = "block";
    this.http.get(environment.API_URL + "getTracks/").subscribe((Response) => {
      if (Response) {
      }
      this.lif = Response;
      this.lift = this.lif.tracks;
      this.displayStyles = "none";
    });
  }
  _returnHtmlFromRichText(richText: any) {
    if (
      richText === undefined ||
      richText === null ||
      richText.nodeType !== "document"
    ) {
      return "<p>Error</p>";
    }
    return documentToHtmlString(richText);
  }
  convertToPlain(rtf: any) {
    rtf = rtf.replace(/\\par[d]?/g, "");
    return rtf
      .replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "")
      .trim();
  }
  htmlToPlaintext(text: any) {
    return text ? String(text).replace(/<[^>]+>/gm, "") : "";
  }
  displayStyle = "none";
  displayStyle2 = "none";
}
